module.exports = __webpack_public_path__ + "img/10.cdd72021.png";